import script from "./addNewCustomer.vue?vue&type=script&setup=true&lang=js"
export * from "./addNewCustomer.vue?vue&type=script&setup=true&lang=js"

import "./addNewCustomer.vue?vue&type=style&index=0&id=82e6d764&scoped=true&lang=less"

import exportComponent from "/Users/april/Desktop/hz_pro_vue3/mail-task-front-end/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-82e6d764"]])

export default __exports__